import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { StageService } from '../proxy/controlling/controllers/stage.service';
import { ReasonService } from '@general/proxy/general/controllers/reason.service';

FieldBuilder.setNamespace('Controlling');

export const CLOSINGSTAGESTATUSPARAMETERS_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey(
    'stageId',
    'Entity.Stage',
    StageService
  )
    .required()
    .displayFromNested('stage.name')
    .sortBy('stage.name')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('minimumAdjustmentReasonId', 'Entity.ClosingStageStatusParameters.MinimumAdjustmentReason', ReasonService)
    .required()
    .display('name') 
    .keyField('id') 
    .build(),
];

export const CLOSINGSTAGESTATUSPARAMETERS_CONFIG = {
  entityName: 'ClosingStageStatusParameters',
  localizationKey: 'Controlling::Entity.ClosingStageStatusParameters',
  fields: CLOSINGSTAGESTATUSPARAMETERS_FIELDS,
  permission: 'ControllingLiquidations.ClosingStageStatusParameterses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
